import AdminLayout from '@/components/feature/AdminLayout';
import { banners } from '@/mocks/admin';
import { news } from '@/mocks/news';

export default function AdminBanners() {
  return (
    <AdminLayout>
      <div className="max-w-6xl mx-auto space-y-8">
        <div>
          <div className="flex items-center justify-between mb-5">
            <h1 className="text-2xl font-bold text-foreground-950">Quản lý banner</h1>
            <button className="px-4 py-2 rounded-md bg-accent-500 text-background-950 text-sm font-semibold hover:bg-accent-600 whitespace-nowrap cursor-pointer transition-colors">
              <i className="ri-add-line mr-1"></i> Thêm banner
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {banners.map((b) => (
              <div key={b.id} className="rounded-xl border border-background-200/60 bg-background-100 overflow-hidden">
                <div className="h-36 w-full">
                  <img src={b.image} alt={b.title} className="w-full h-full object-cover object-top" />
                </div>
                <div className="p-4">
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-semibold text-foreground-950">{b.title}</p>
                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${b.active ? 'bg-emerald-500/15 text-emerald-400' : 'bg-foreground-500/15 text-foreground-600'}`}>
                      {b.active ? 'Đang hiển thị' : 'Ẩn'}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-600 mt-1">Cập nhật: {b.updated}</p>
                  <div className="flex gap-2 mt-3">
                    <button className="px-3 py-1.5 rounded-md border border-background-300/60 text-xs font-semibold text-foreground-700 hover:border-accent-500 hover:text-accent-400 whitespace-nowrap cursor-pointer transition-colors">Chỉnh sửa</button>
                    <button className="px-3 py-1.5 rounded-md border border-background-300/60 text-xs font-semibold text-foreground-700 hover:border-rose-400 hover:text-rose-400 whitespace-nowrap cursor-pointer transition-colors">Xóa</button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-xl font-bold text-foreground-950">Quản lý tin tức</h2>
            <button className="px-4 py-2 rounded-md bg-accent-500 text-background-950 text-sm font-semibold hover:bg-accent-600 whitespace-nowrap cursor-pointer transition-colors">
              <i className="ri-add-line mr-1"></i> Thêm tin tức
            </button>
          </div>

          <div className="overflow-x-auto rounded-xl border border-background-200/60">
            <table className="w-full text-sm min-w-[640px]">
              <thead>
                <tr className="bg-background-100 text-left">
                  <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Tiêu đề</th>
                  <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Danh mục</th>
                  <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600">Ngày đăng</th>
                  <th className="px-4 py-3 text-xs font-semibold uppercase tracking-wide text-foreground-600 text-right">Thao tác</th>
                </tr>
              </thead>
              <tbody>
                {news.map((n) => (
                  <tr key={n.id} className="border-t border-background-200/40 hover:bg-background-100/60 transition-colors">
                    <td className="px-4 py-3 text-foreground-950 font-medium">{n.title}</td>
                    <td className="px-4 py-3"><span className="px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-400 text-xs font-semibold whitespace-nowrap">{n.category}</span></td>
                    <td className="px-4 py-3 text-foreground-600 whitespace-nowrap">{n.date}</td>
                    <td className="px-4 py-3 text-right whitespace-nowrap">
                      <button className="px-3 py-1.5 rounded-md border border-background-300/60 text-xs font-semibold text-foreground-700 hover:border-accent-500 hover:text-accent-400 cursor-pointer transition-colors mr-1">Sửa</button>
                      <button className="px-3 py-1.5 rounded-md border border-background-300/60 text-xs font-semibold text-foreground-700 hover:border-rose-400 hover:text-rose-400 cursor-pointer transition-colors">Xóa</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}